export default "__VITE_ASSET__DNxwFFNe__"